import { render, staticRenderFns } from "./ProjectManagerModal.vue?vue&type=template&id=70e5cbc0&scoped=true&"
import script from "./ProjectManagerModal.vue?vue&type=script&lang=js&"
export * from "./ProjectManagerModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManagerModal.vue?vue&type=style&index=0&id=70e5cbc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5cbc0",
  null
  
)

export default component.exports